/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type ClaimOwnershipInput = {
    readonly clientMutationId: string;
    readonly invitationId: string;
};
export type claimProfileMutationVariables = {
    readonly input: ClaimOwnershipInput;
};
export type claimProfileMutationResponse = {
    readonly claimProfileOwnerShip: {
        readonly clientMutationId: string;
        readonly errors: ReadonlyArray<{
            readonly id: string;
            readonly location: string | null;
        } | null> | null;
        readonly hasErrors: boolean | null;
        readonly person: {
            readonly id: string;
            readonly fullName: string | null;
            readonly landingPageUrl: string | null;
        } | null;
        readonly entity: {
            readonly id: string;
            readonly name: string | null;
            readonly landingPageUrl: string | null;
        } | null;
    } | null;
};
export type claimProfileMutation = {
    readonly response: claimProfileMutationResponse;
    readonly variables: claimProfileMutationVariables;
};



/*
mutation claimProfileMutation(
  $input: ClaimOwnershipInput!
) {
  claimProfileOwnerShip(input: $input) {
    clientMutationId
    errors {
      id
      location
    }
    hasErrors
    person {
      id
      fullName
      landingPageUrl
    }
    entity {
      id
      name
      landingPageUrl
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ClaimOwnershipInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "claimProfileOwnerShip",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateDeleteUpdatePersonPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasErrors",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "person",
        "storageKey": null,
        "args": null,
        "concreteType": "Person",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fullName",
            "args": null,
            "storageKey": null
          },
          (v2/*: any*/)
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "entity",
        "storageKey": null,
        "args": null,
        "concreteType": "Entity",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          (v2/*: any*/)
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "claimProfileMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "claimProfileMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "claimProfileMutation",
    "id": null,
    "text": "mutation claimProfileMutation(\n  $input: ClaimOwnershipInput!\n) {\n  claimProfileOwnerShip(input: $input) {\n    clientMutationId\n    errors {\n      id\n      location\n    }\n    hasErrors\n    person {\n      id\n      fullName\n      landingPageUrl\n    }\n    entity {\n      id\n      name\n      landingPageUrl\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '1b17ec97fc572c3b80e0b4c70e51f06e';
export default node;
